import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
import createPersistedState from 'vuex-persistedstate'
import createMutationsSharer from 'vuex-shared-mutations'
import Mtxs from '@/constants/Mutations'
import RegisterVuexORM from '@/store/RegisterVuexORM'

// import { mutationLogger, actionLogger } from 'vuex-trace'

Vue.use(Vuex)

let getPlugins = () => {
  let plugins = [
    createMutationsSharer({
      predicate: [
        `admin/${Mtxs.SET_AUTH_EXPIRY}`,
        `admin/${Mtxs.SET_AUTH_LOGGED_OUT}`,
        'shop/SET_SHOP_VALUE',
      ],
    }),
    RegisterVuexORM(),
  ]
  // if (process.env.NODE_ENV !== 'production') {
  //   plugins = [...plugins, mutationLogger(), actionLogger()]
  // }

  if (typeof window !== 'undefined') {
    plugins.push(
      createPersistedState({
        paths: [
          'auth.user',
          'auth.token',
          'auth.sessionExpiry',
          'cart.orderId',
        ],
      })
    )
  }
  return plugins
}

const store = new Vuex.Store({
  namespaced: true,
  plugins: getPlugins(),
  modules,
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== 'production',
})

store.subscribeAction({
  // before: (action) => {
  //   console.log(`before action ${action.type}`)
  // },
  after: (action) => {
    switch (action.type) {
      case 'auth/logout':
        // router.push({
        //   name: MerchantRoutes.LOGIN,
        //   query: { loggedOut: true },
        // })
        break
      default:
        // console.log(`after action ${action.type}`)
        break
    }
  },
})

export default store
